

























































import { Vue, Component } from 'vue-property-decorator';
import SearchBar from '@/components/next/SearchBar.vue';
import { isWeiXin } from '@/common/ts/common';
import { getUserList, deleteData } from '../api';
import { Icon, List, Lazyload, Dialog, Toast, Popup, PullRefresh } from 'vant';
Vue.use(List)
  .use(Lazyload)
  .use(Dialog)
  .use(Toast)
  .use(Popup)
  .use(Icon);
@Component({
  components: {
    SearchBar,
    [PullRefresh.name]: PullRefresh,
  },
})
export default class Home extends Vue {
  search = '';
  list: any[] = [];
  objCounty: any = {};
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  refreshing: boolean = false;
  show: boolean = true;
  workType: any = this.$route.query.workType;
  placeholder: any = '请输入作者或作品名称';
  showPop: boolean = false;
  title: string = '';
  isLoading: boolean = true;
  
  async created() {
    const unionid = window.localStorage.getItem('unionid');
    if (isWeiXin() && !unionid) {
      this.WechatLogin();
    }
  }
  WechatLogin() {
    if (isWeiXin()) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }

  onLoad() {
    const data = {
      udid: window.udid,
      appkey: window.appkey,
      token: window.gettoken(),
      unionid: window.localStorage.getItem('unionid'),
      page: this.page,
    };
    getUserList(data).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  onRefresh() {
    this.page = 1;
    this.list = [];
    this.show = false;
    this.onLoad();
    setTimeout(() => {
      this.show = true;
      this.isLoading = false;
    }, 500);
  }
  onSearch() {
    this.finished = false;
    this.page = 1;
    this.list = [];
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 500);
  }
  userInputChange(text: string) {
    this.search = text;
  }
  clear() {
    this.list = [];
    this.page = 1;
    this.finished = false;
  }
  goDetail(id: any, enable: any) {
    this.$router.push(`Detail?id=${id}`);
  }
  async deleteData(id:any){
    const res: any = await deleteData(id);
    console.log(res);
    if (res.code === 200) {
      Toast(`${res.msg}`);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      Toast(`${res.msg}`);
    }
  }
}
